import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { English } from "./English";
import { German } from "./German";

const SUPPORTED_LANGUAGES = ["de", "en", "en-US"];
const FALLBACK_LANGUAGE = "de";

let language = localStorage.getItem("i18nextLng");
if (language && !SUPPORTED_LANGUAGES.includes(language)) {
  localStorage.removeItem("i18nextLng");
  language = FALLBACK_LANGUAGE;
  localStorage.setItem("i18nextLng", FALLBACK_LANGUAGE);
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: language,
    debug: true,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    saveMissing: false,
    resources: {
      de: German,
      en: English,
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18next;
